import Vue from 'vue'
import store from './store'
import config from 'src/config/defaultSettings'

export default function Initializer ()
{
    // 菜单类型
    store.commit('config/SET_SIDEBAR_TYPE', store.getters["config/sidebar"] || true);
    // 整体风格
    store.commit('config/TOGGLE_THEME', store.getters["config/theme"] || config.navTheme);
    // 主体颜色
    store.commit('config/TOGGLE_COLOR', store.getters["config/color"] || config.primaryColor);
    // 导航模式
    store.commit('config/TOGGLE_LAYOUT_MODE',store.getters["config/layout"] || config.layout);
    // 内容布局
    store.commit('config/TOGGLE_CONTENT_WIDTH', store.getters["config/contentWidth"] ||  config.contentWidth);
    // 固定 Header
    store.commit('config/TOGGLE_FIXED_HEADER', store.getters["config/fixedHeader"] || config.fixedHeader);
    // 下滑时隐藏 Header
    store.commit('config/TOGGLE_FIXED_HEADER_HIDDEN', store.getters["config/autoHideHeader"] || config.autoHideHeader);
    // 固定左侧菜单
    store.commit('config/TOGGLE_FIXED_SIDERBAR', store.getters["config/fixSiderbar"] || config.fixSiderbar);
    // 更换色弱模式
    store.commit('config/TOGGLE_WEAK', store.getters["config/weak"] || config.colorWeak);
    // 更换多tab模式
    store.commit('config/TOGGLE_MULTI_TAB', store.getters["config/multiTab"] || config.multiTab);
}
